import React from 'react';
import {Flex, Link, Text} from "@chakra-ui/react";
import DownloadIcon from "../../../../utils/icons/downloadIcon";
import {Color} from "../../../../theme/color";
import { useTranslation } from 'react-i18next';

export const UsefulLinks = ({ actionText, file }: { actionText: string, file?: string }) => {
    const { t } = useTranslation();

    return (
        <Flex direction='column'>
            <Text fontWeight='600' pb='2px'>{ t('onboarding.links.usefulLinks')}</Text>
            <Flex gap='22px'>
                <Text color='white'>{actionText}</Text>
                    <Link href={file}>
                        <Flex alignItems='center' gap='6px'>
                            <DownloadIcon/>
                            <Text color={Color.HASHUP}>{t('onboarding.links.downloadPdf')}</Text>
                        </Flex>
                    </Link>
            </Flex>
        </Flex>
    );
};

export default UsefulLinks;
